export enum DatePickerMode {
    Single = 'single',
    Range = 'range',
}

export type InputDatePickerProps = {
    id: string
    allowInput?: boolean
    className?: string
    disabled?: boolean
    hasError?: boolean
    hideLabel?: boolean
    label: string
    mode: DatePickerMode
    minDate?: string // YYYY-MM-DD
    maxDate?: string // YYYY-MM-DD
    onChange: any
    placeholder?: string
    required?: boolean
    value: string[]
    defaultValue?: string
    errorText?: string
}
